<template>
  <div class="container-fluid mt-2">
    <div class="form-group row">
      <div class="col-sm-2 text-md-right text-sm-center">
        <label>Número Protocolo:</label>
      </div>
      <div class="col-md-8 col-sm-10">
        <div class="form-group input-group" :class="{
          'form-group--error': $v.anexar.processoAnexado.$error
        }">
          <auto-complete-comp
            class="form__input autocomplete w-100"
            :isAsync="true"
            :url="urlAutoComplete"
            :width="100"
            :marginBottom="10"
            mutation="MUT_ANEXAR_PROCESSO_SELECIONADO"
            keyAttrName="id"
            keyAttrFilter="numeroProcesso"
            valueAttrName="processo"
            :params="autoCompleteParams">
          </auto-complete-comp>
        </div>
        <div class="error" v-if="!$v.anexar.processoAnexado.required">{{ errorMessage }}</div>
      </div>
      <div class="col-md-2 col-sm-12 text-md-right text-sm-center">
        <button type="button" class="btn btn-outline-primary mb-1" @click.prevent="$refs.confirmacaoAnexar.openModal()">Anexar</button>
      </div>
    </div>
    <modal ref="confirmacaoAnexar" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3 cormsgaviso" v-if="anexar.processoAnexado">Protocolos anexados serão finalizados e podem ser desanexado se: 1) Processo estiver sob posse de quem anexou o processo ou documento. 2) Quando o processo nao foi tramitado depois que o mesmo foi anexado. Deseja realmente anexar o protocolo
             {{ formatarProtocolo(anexar.processoAnexado).value }} ao {{ formatarProtocolo(numeroProcesso).value }}?</h4>
          <h4 class="text-primary m-3" v-if="!anexar.processoAnexado">É preciso um número protocolo selecionado para poder anexar</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.confirmacaoAnexar.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="$refs.confirmacaoAnexar.closeModal()">Cancelar</button>
          <button v-if="anexar.processoAnexado" type="button" class="btn btn-outline-primary m-1" @click.prevent="anexarProtocolo()">Confirmar</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import autoCompleteComp from '@/components/autocomplete/AutoCompleteComp'
import modal from '@/components/shared/Modal.vue'

import eventBus from '@/uteis/eventBus'

import VirtusService from '@/services/VirtusService'

import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import { componentIsVisible, rules } from '@/uteis/action/permissao'

export default {
  name: 'formularioApensar',

  components: {
    autoCompleteComp,
    modal
  },

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String },
    eventBusRecarregar: { required: true, type: String },
    numeroProcesso: { required: true, type: String }
  },

  data () {
    return {
      formulario: {
        offset: 1,
        range: this.rowsNumber
      },
      autoCompleteParams: {
        numeroProcesso: '',
        numeroGuia: '',
        remetente: '',
        municipio: '',
        assunto: '',
        interessado: '',
        autoComplete: true
      },
      errorMessage: 'O campo é obrigatório',
      anexar: {
        processoAnexado: '',
        processo: ''
      },
      processoSelecionado: {},
      urlAutoComplete: '/d0593/pae-back/v1/protocolos/setor/parent',
      filtroProcesso: {
        numeroProcesso: '',
        remetente: '',
        cidade: '',
        assunto: '',
        interessados: '',
        offset: 1,
        range: this.rowsNumber,
        armazenado: false,
        arquivado: false,
        anexado: false,
        consulta: 'setor'
      },
      processo: '',
      papel: ''
    }
  },

  created () {
    this.service = new VirtusService()

    this.anexar.processo = this.$route.query.numeroProcesso
    var sessao = this.$store.getters.getDadosSessao.sessao
    this.autoCompleteParams.tipoIdentificador = 'ID'
    this.autoCompleteParams.identificador = sessao.idDepartamento
    this.papel = this.$store.getters.getDadosSessao.sessao.papeis.split('|')
    this.anexar.solicitante = {
      tipo: 'PESSOA',
      titulo: sessao.nomeUsuario,
      identificador: sessao.login,
      tipoIdentificador: 'LOGIN'
    }

    this.pesquisarProcesso(this.$route.query.numeroProcesso)
  },

  validations: {
    anexar: {
      processoAnexado: {
        required
      }
    }
  },

  computed: mapState({
    processoAnexado: state => state.anexarProcessoSelecionado.processo,
    processoSelecionadoAnexado: state => state.anexarProcessoSelecionado
  }),

  watch: {
    processoAnexado (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$v.anexar.processoAnexado.$model = newValue
      }
    },
    processoSelecionadoAnexado (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.processoSelecionado = newValue
      }
    }
  },

  methods: {
    anexarProtocolo () {
      this.errorMessage = 'O campo é obrigatório'

      const { ANEXAR_PROTOCOLO } = rules

      if (!componentIsVisible(ANEXAR_PROTOCOLO) &&
          !(this.processoSelecionado.atributos.tipoProtocolo === 'Documento avulso')) {
        this.errorMessage = 'Não tem permissão para anexar protocolo do tipo Processo'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      if (this.anexar.processoAnexado === this.anexar.processo) {
        this.errorMessage = 'Não pode anexar o mesmo número de protocolo'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
      }

      if (this.isApensado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode anexar um protocolo já apensado'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      if (this.isApensando(this.processoSelecionado)) {
        this.errorMessage = 'Não pode anexar um protocolo que já está apensando outro'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      if (this.isAnexado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode anexar um protocolo já anexado'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      if (this.isArmazenado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode anexar um protocolo armazenado, favor desarmazenar processo para anexação'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      if (this.isArquivado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode anexar um protocolo arquivado, favor desarquivar o processo para anexação'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      if (this.isEliminado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode anexar um protocolo eliminado, favor desfazer a eliminação do processo para anexação'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      if ((this.processoSelecionado.atributos.tipoProtocolo === 'Processo') &&
        (this.processo.atributos.tipoProtocolo === 'Documento avulso')) {
        this.errorMessage = 'Não pode anexar um protocolo do tipo Processo em um protocolo do tipo Documento avulso'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      if (this.processo.atributos.tipoProtocolo !== 'Processo') {
        this.errorMessage = 'O protocolo pai é preciso ser do tipo Processo'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO')
        this.$v.anexar.processoAnexado.$model = ''
        this.processoSelecionado = {}
      }

      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$refs.confirmacaoAnexar.closeModal()
        return
      }

      this.service.anexar(this.anexar).then((response) => {
        this.$refs.confirmacaoAnexar.closeModal()
        eventBus.$emit(this.eventBusRecarregar, response)
      }).catch(err => {
        console.log('Erro ao anexar Protocolo', err)
      })
    },

    isApensado: (obj) => obj.apensadoEm && obj.apensadoEm !== '',
    isAnexado: (obj) => obj.anexadoEm && obj.anexadoEm !== '',
    isApensando: (obj) => obj.apensados,
    isArmazenado: (obj) => obj.atributos ? obj.atributos.armazenado : false,
    isArquivado: (obj) => obj.atributos.arquivado,
    isEliminado: (obj) => obj.atributos.remocao,

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo)
    },

    pesquisarProcesso (numeroProtocolo) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.filtroProcesso.tipoIdentificador = 'ID'
      this.filtroProcesso.identificador = dadosSessao.sessao.idDepartamento
      this.filtroProcesso.numeroProcesso = numeroProtocolo
      this.service.consultarNoSetor(this.filtroProcesso).then(res => {
        if (res.data[0]) {
          this.processo = res.data[0]
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>

<style style scoped lang="scss"> //lang="stylus" scoped

.cormsgaviso {
  background-color: lightyellow;
}

</style>
